import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2OralAssignmentIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 47.5 47.5",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: normalizeStrokeWidth(strokeWidth, 47.5),
    children: [/*#__PURE__*/jsx("path", {
      d: "M22.25 31.25h6v9l9-9h6a3 3 0 003-3v-24a3 3 0 00-3-3h-24a3 3 0 00-3 3"
    }), /*#__PURE__*/jsx("circle", {
      cx: "8.75",
      cy: "13.25",
      r: "6"
    }), /*#__PURE__*/jsx("path", {
      d: "M16.25 34.25v-4.5a7.5 7.5 0 10-15 0v4.5h3l1.5 12h6l1.5-12zM36.324 10.902l-5.8 7.748a1.5 1.5 0 01-2.26.16l-3-3"
    })]
  });
};

export { PM2OralAssignmentIcon };
//# sourceMappingURL=oral-assignment.js.map
